export default class {
  constructor () {
    this.alerts = []
  }

  add (category, text) {
    this.alerts.push({
      key: category,
      text: text
    })
  }
  remove (category) {
    if (category.constructor === String) {
      category = [category]
    }
    for (let i = this.alerts.length - 1; i >= 0; i--) {
      let obj = this.alerts[i]
      if (category.indexOf(obj.key) >= 0) {
        this.alerts.splice(i, 1)
      }
    }
  }

  get () {
    if (this.alerts.length) {
      return this.alerts[0]
    }
    return false
  }

  empty () {
    return this.alerts.length <= 0
  }

  clear () {
    this.alerts = []
    this.nextIndex = 0
    return true
  }
}
